import { render, staticRenderFns } from "./placard_manuscript_preview.vue?vue&type=template&id=64923374&scoped=true"
import script from "./placard_manuscript_preview.vue?vue&type=script&lang=js"
export * from "./placard_manuscript_preview.vue?vue&type=script&lang=js"
import style0 from "./placard_manuscript_preview.vue?vue&type=style&index=0&id=64923374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64923374",
  null
  
)

export default component.exports